import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import ClientTitle from './title/ClientTitle';
import ClientStatus from './client_status/ClientStatus';
import ClientShowSettings from './ClientShowSettings';
import ClientAnnouncement from './announcement/ClientAnnouncement';

const ClientHeader = (props) => {
  const clientRn = props.clientRn;
  const clientData = props.clientData;
  const clientForms = props.clientForms;
  const clientLogs = props.clientLogs;
  const clientBackend = props.clientBackend;
  const clientCareplan = props.clientCareplan;
  const clientCallStatus = props.clientCallStatus;
  const clientOwnerData = props.clientOwnerData;
  const refresh = props.refresh;
  const setRefresh = props.setRefresh;
  const showSettings = props.showSettings;
  const setOpenDrawerView = props.setOpenDrawerView;
  return (
    <Stack>
      <ClientTitle
        clientRn={clientRn}
        clientData={clientData}
        clientBackend={clientBackend}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <Stack direction={{md: 'row', xs: 'column'}}>
        <ClientStatus
          clientRn={clientRn}
          clientForms={clientForms}
          clientLogs={clientLogs}
          clientCareplan={clientCareplan}
          clientData={clientData}
          clientBackend={clientBackend}
          clientCallStatus={clientCallStatus}
          clientOwnerData={clientOwnerData}
        />
      </Stack>
      <ClientAnnouncement
        clientRn={clientRn}
        clientData={clientData}
        clientBackend={clientBackend}
      />
      <ClientShowSettings
        clientRn={clientRn}
        clientData={clientData}
        clientBackend={clientBackend}
        showSettings={showSettings}
        setOpenDrawerView={setOpenDrawerView}
      />
    </Stack>
  );
};
ClientHeader.propTypes = {
  clientRn: PropTypes.string.isRequired,
  clientData: PropTypes.object.isRequired,
  clientForms: PropTypes.array,
  clientLogs: PropTypes.object.isRequired,
  clientCareplan: PropTypes.object,
  clientBackend: PropTypes.object.isRequired,
  clientCallStatus: PropTypes.string,
  clientOwnerData: PropTypes.object,
  refresh: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
  showSettings: PropTypes.bool.isRequired,
  setOpenDrawerView: PropTypes.func.isRequired,
};

export default React.memo(ClientHeader);
